// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"b81e949c","520":"50b00ed6","707":"2257011d","776":"cd57f436","787":"8e97cfac","947":"cd408a88"}[chunkId] + ".chunk.js";
};